import {
  Formatter,
  WSDataItem,
  WSList,
  WSPanel,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import { FormatterInput } from "@wingspanhq/fe-component-library/dist/utils/formatters/formatter";
import {
  SignatureRequest,
  SignatureResponseItemType
} from "@wingspanhq/wingspan-api-sdk";
import React from "react";

const formatter = new Formatter({
  noDataIndicator: "–",
  trueIndicator: "Yes",
  falseIndicator: "No"
});

export const SignaturesFieldsWidget: React.FC<{
  signatureRequest?: SignatureRequest;
}> = ({ signatureRequest }) => {
  if (!signatureRequest?.responseItems?.length) {
    return null;
  }

  return (
    <WSList gap="S">
      <WSSectionToolbar title="E-signature fields" />
      <WSPanel>
        <WSList>
          {signatureRequest.responseItems.map(
            ({ name, value, type }, index) => {
              let parsedValue: FormatterInput = value;

              if (type === SignatureResponseItemType.DATE_SIGNED) {
                parsedValue = new Date(value);
              }

              return (
                <WSDataItem
                  key={index}
                  formatter={formatter}
                  formatterOptions={{
                    dateType: "monthDayYear"
                  }}
                  label={name}
                  value={parsedValue}
                />
              );
            }
          )}
        </WSList>
      </WSPanel>
    </WSList>
  );
};
